<template>
  <div >
    <el-form :model="userInfo" :rules="rules" ref="userInfo" class="infoForm">
        <el-form-item class="infoInput" prop="personNo">
            <el-input v-model="userInfo.personNo" placeholder="学工号" :disabled="userInfo.personNoStatus" maxlength="25"></el-input>
        </el-form-item>
       <send-code ref="getPhoneInfo" @submitRegForm="getIdentity('userInfo')" :code-info="codeInfo"></send-code>
        <el-form-item class="infoBtn">
          <el-button type="primary" @click="getIdentity('userInfo')">更新</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {checkName,checkCode,checkStudentId} from '../../../config/formCheck'
  import SendCode from '../../../public/sendCode'
export default {
  name: "infoForm",
    components: {
      sendCode:SendCode
    },
  data() {
    return {
      userInfo: {
        personNo:"",
        personNoStatus:"",
        token:"",
        phoneNo:""
      },
      codeInfo:{
          errorMsg:""
        },
       rules: {
          student_name: [
            { validator: checkName, trigger: 'change' }
          ],
          student_id: [
            { validator: checkStudentId, trigger: 'change' }
          ],
        },
    };
  },
  mounted(){
    const personNo = sessionStorage.getItem("officeEmail_personNo")
    if(personNo !=""){
      this.userInfo.personNo = personNo;
      this.userInfo.personNoStatus = true;
    }else{
      this.userInfo.personNoStatus = false;
    }
  },
  methods: {
      //验证身份
      getIdentity(userInfo){
        let self = this
         self.$refs[userInfo].validate((valid) => {
          if (valid) {
            self.$refs['getPhoneInfo'].validatePhone((valid)=>{
              if(valid){
                const loading = self.$loading({
                  lock: true,
                  text: '正在验证中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                self.codeInfo.errorMsg =""
                const phoneInfo = self.$refs.getPhoneInfo.phoneInfo
                const personNo = self.userInfo.personNo
                const phoneNo = phoneInfo.phone
                const msgCode = phoneInfo.code
                const url = '/email/updatePersonMoblie?personNo='+personNo+'&personMoblie='+phoneNo+'&code='+msgCode
                self.postRequest(url,{}).then((result)=>{
                    console.log("更新手机号：",result.data)
                    loading.close();
                    if(result.data){
                      if(result.data.msgStatus == "1"){
                        self.$router.push({ name: 'CheckIdentity'})
                      }else if(result.data.msgStatus == "2"){
                        // 验证码错误
                         self.$alert("验证码错误", '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else{
                        self.$alert("系统错误，请稍后再试", '错误提示', {
                          confirmButtonText: '确定',
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }
                    }
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        //
      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.infoForm {
  margin-top: 38px;
}
.infoInput {
  width: 308px;
  height: 41px;
  margin: 0 auto;
  margin-top: 18px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
  }
  .infoBtn button{
    width: 310px;
  }
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/updatePhone/infoForm.vue